import {
  DriveSourceListResult,
  GoogleDriveSourceDeleteResult,
  GoogleDriveSourceListResult,
  GoogleDriveSourceStartResult,
  MicrosoftTenantConsentStartResult,
  MicrosoftTenantDeleteResult,
  MicrosoftTenantListResult,
  RelayCreateInput,
  RelayCreateResult,
  RelayListResult,
  RelaySafe,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listDriveSources(): Promise<DriveSourceListResult> {
  return httpClient.get<DriveSourceListResult>('/protected/drive-sources');
}

export async function listMicrosoftTenantSources(): Promise<MicrosoftTenantListResult> {
  return httpClient.get<MicrosoftTenantListResult>('/protected/drive-sources/microsoft');
}

export async function startMicrosoftTenantConsent(): Promise<MicrosoftTenantConsentStartResult> {
  return httpClient.post<MicrosoftTenantConsentStartResult>('/protected/drive-sources/microsoft/start');
}

export async function deleteMicrosoftTenantSource(sourceId: number): Promise<MicrosoftTenantDeleteResult> {
  return httpClient.delete<MicrosoftTenantDeleteResult>(`/protected/drive-sources/microsoft/${sourceId}`);
}

export async function listGoogleDriveSources(): Promise<GoogleDriveSourceListResult> {
  return httpClient.get<GoogleDriveSourceListResult>('/protected/drive-sources/google');
}

export async function startGoogleDriveSourceConnect(): Promise<GoogleDriveSourceStartResult> {
  return httpClient.post<GoogleDriveSourceStartResult>('/protected/drive-sources/google/start');
}

export async function deleteGoogleDriveSource(sourceId: number): Promise<GoogleDriveSourceDeleteResult> {
  return httpClient.delete<GoogleDriveSourceDeleteResult>(`/protected/drive-sources/google/${sourceId}`);
}

export async function listRelays(): Promise<RelayListResult> {
  return httpClient.get<RelayListResult>('/protected/drive-sources/relays');
}

export async function createRelay(input: RelayCreateInput): Promise<RelayCreateResult> {
  return httpClient.post<RelayCreateResult>('/protected/drive-sources/relays', input);
}

export async function revokeRelay(relayId: number): Promise<RelaySafe> {
  return httpClient.post<RelaySafe>(`/protected/drive-sources/relays/${relayId}/revoke`);
}
